import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.943 1.92a.84.84 0 0 0-.84.84v13.026l-5.236-5.26a.841.841 0 0 0-1.19 1.188l6.673 6.673c.04.038.081.073.126.105h.034l.109.058h.05a.464.464 0 0 0 .11.03.75.75 0 0 0 .164 0 .485.485 0 0 0 .273-.03h.05l.11-.058h.033l.13-.105 6.668-6.673a.84.84 0 0 0-1.189-1.189l-5.235 5.24V2.76a.84.84 0 0 0-.84-.84ZM5.27 22.147h13.345a.84.84 0 1 0 0-1.68H5.27a.84.84 0 1 0 0 1.68Z"
    }
  )
);
var SvgDownloadFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DownloadFilled_default = SvgDownloadFilled;

export { DownloadFilled_default as default };
